<!-- index.html in <head> section -->
  <link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
/>

<div class="background">
  <!-- Background Slider -->
  <!-- <div class="slider">
    <div *ngFor="let image of backgroundImages; let i = index"
         class="slide"
         [class.active]="i === currentSlide"
         [style.background-image]="'url(' + image + ')'">
    </div>
  </div> -->

  <div
  *ngFor="let image of backgroundImages; let i = index"
  class="slide"
  [class.active]="i === currentSlide"
  [style.background-image]="'url(' + image + ')'"
  [style.animation-delay]="(i * 2) + 's'">
</div>


  <!-- Overlay Content -->
  <div class="overlay">
    <!-- Header -->
    <!-- <div class="header">
      <div class="logo-text">National Livestock Advisory System</div>
    </div> -->
    <!-- <div class="logo-group">
      <img src="../../assets/images/logo/ic_dls.png" alt="Logo 1" class="logo-img" />
      <img src="../../assets/images/logo/ic_rimes.png" alt="Logo 2" class="logo-img" />
      <img src="../../assets/images/logo/ic_gov.png" alt="Logo 3" class="logo-img" />
    </div> -->
    <!-- <div class="qr-footer">
      <a href="../../assets/images/qr_download.png" target="_blank" matTooltip="Scan to download the NLAS App">
        <img src="../../assets/images/qr_download.png" alt="Download NLAS App" class="qr-code-img-footer" />
      </a>
    </div> -->

    <!-- Main Content -->
    <div class="main-content">
      
      <div class="weather-card glass" style="position: relative; padding-top: 4rem;">
        <!-- Logos -->

        <div class="logo-group">
          <div class="logo-wrapper">
          <img src="../../assets/images/logo/ic_dls.png" alt="Logo 1" class="logo-img" />
          </div>
          <div class="logo-wrapper">
          <img src="../../assets/images/logo/ic_gov.png" alt="Logo 2" class="logo-img" />
          </div>
          <div class="logo-wrapper">
          <img src="../../assets/images/logo/ic_rimes.png" alt="Logo 3" class="logo-img" />
          </div>
        </div>

        <div class="small-header">
          NATIONAL LIVESTOCK ADVISORY SYSTEM NLAS
        </div>
        
        <!-- <div class="data-cards">
          <div class="data-card alert-card">
            <div class="card-icon"><i class="fas fa-bell"></i></div>
            <div class="card-text">
              <h3>THI Ruminant Alert</h3>
              <p>536 Locations</p>
            </div>
          </div>
          <div class="data-card rain-card">
            <div class="card-icon"><i class="fas fa-cloud-showers-heavy"></i></div>
            <div class="card-text">
              <h3>Rainfall Alert</h3>
              <p>36 Locations</p>
            </div>
          </div>
          <div class="data-card boiler-card">
            <div class="card-icon"><i class="fas fa-temperature-low"></i></div>
            <div class="card-text">
              <h3>THI Boiler Alert</h3>
              <p>0 Locations</p>
            </div>
          </div>
          <div class="data-card layer-card">
            <div class="card-icon"><i class="fas fa-egg"></i></div>
            <div class="card-text">
              <h3>THI Layer Alert</h3>
              <p>0 Locations</p>
            </div>
          </div>
        </div> -->




                <!-- Navigation Buttons -->
        <!-- <nav class="nav-buttons">
          <button routerLink="/dashboard">🏡 Dashboard</button>
          <button routerLink="/forecast">📊 Forecast</button>
          <button routerLink="/advisory">📘 Advisory</button>
        </nav> -->



        <div class="nav-grid" style="margin-top: auto;">
          <a routerLink="/dashboard" class="nav-tile"><i class="fas fa-home"></i><span>Dashboard</span></a>
          <a routerLink="/dashboard/weather_alert" class="nav-tile"><i class="fas fa-cloud-sun"></i><span>Alert</span></a>
          <a routerLink="/dashboard/weather_forecast" class="nav-tile"><i style="margin-left: 10px;" class="fas fa-temperature-high"></i><span>Forecast</span></a>
          <a routerLink="/dashboard/fmd_cluster" class="nav-tile"><i class="fas fa-chart-line"></i><span>Analytics</span></a>
          <a routerLink="/dashboard/advisory_regional" class="nav-tile"><i class="fas fa-book-open"></i><span>Advisory</span></a>
          <a routerLink="/dashboard/flood-magnitude" class="nav-tile"><i class="fas fa-water"></i><span>Flood Map</span></a>
        </div>



        
        <!-- <div class="bottom-center-logos">
          <img src="../../assets/images/logo/ic_care_sa.png" style="width: 200px;" alt="Logo 4" />
          <img src="../../assets/images/logo/ic_world_bank.png" alt="Logo 5" />
        </div> -->


        <div class="glow-line" style="animation-delay: -1s;"></div>
        <div class="glow-line" style="animation-delay: -1.05s;"></div>
        <div class="glow-line" style="animation-delay: -1.10s;"></div>
        <div class="glow-line" style="animation-delay: -1.15s;"></div>
        <div class="glow-line" style="animation-delay: -1.20s;"></div>
        <div class="glow-line" style="animation-delay: -1.25s;"></div>
        <div class="glow-line" style="animation-delay: -1.30s;"></div>

        
     


        
      </div>

      <div class="qr-footer qr-right">
        <a href="https://play.google.com/store/apps/details?id=com.nlas.app&hl=en&pli=1" target="_blank" matTooltip="Scan to download the NLAS App">
          <img src="../../assets/images/qr_download.png" alt="Download NLAS App" class="qr-code-img-footer" />
        </a>
      </div>
    </div>
  </div>




  <!-- Floating About Icon -->
  <a routerLink="/dashboard/about" class="info-float" title="About"  matTooltip="About">
    <i class="fas fa-circle-info"></i>
  </a>



  
  
  <!-- Floating QR Code -->
<!-- <a href="../../assets/images/qr_download.png" target="_blank" class="qr-float" matTooltip="Scan to download the NLAS App">
  <img src="../../assets/images/qr_download.png" alt="Download NLAS App" class="qr-code-img" />
</a> -->





<!-- right side top qr code -->
<!-- <div class="floating-icons">
  <div class="qr-container">
    <a href="../../assets/images/qr_download.png" target="_blank" matTooltip="Scan to download the NLAS App">
      <img src="../../assets/images/qr_download.png" alt="Download NLAS App" class="qr-code-img" />
    </a>
  </div>
</div> -->








</div>